
import Big from 'big.js'

import { getEditedAt } from '$lib/components/document/doc_types'
import { generateId } from '$lib/factories'

import type { DocShippingItem, DocShippingItemOptions } from './types'



export function makeDocShippingItem(options?: DocShippingItemOptions): DocShippingItem {
	const docItem: DocShippingItem = {
		id: '',
		doc_id: '',
		// shipping_item_id: '',
		idx: 0,
		name: '',
		price: Big(0),
		tax: Big(0),
		taxes: [], //invoice.taxes.map((tax) => tax.id)
		tax_totals: {},
		subtotal: Big(0),
		total: Big(0),
		edited_at: getEditedAt()
	}

	options = options || {}
	options.id = options.id || generateId()

	return { ...docItem, ...options }
}